<!-- ======= Hero Section ======= -->
<section id="hero">
<div id="heroCarousel" data-bs-interval="5000" class="carousel slide carousel-fade" data-bs-ride="carousel">

    <div class="carousel-inner" role="listbox">

    <!-- Slide 1 -->
    <div class="carousel-item active" style="background-image: url(../assets/images/home/domegram\ chinnasthli77.JPG);">
        <div class="carousel-container">
        <div class="carousel-content animate__animated animate__fadeInUp">
            <h3> <span>Panchaleshwar</span></h3>
            <!-- <p> पांचाळेश्वर गवतमी तटकरे मध्यान काळी प्रभू नित्याने करी भोजना सुरपती त्या आत्मचरित्र</p>
            <div class="text-center"><a href="" class="btn-get-started">Read More</a></div> -->
        </div>
        </div>
    </div>

    <!-- Slide 2 -->
    <div class="carousel-item" style="background-image: url(../assets/images/home/faltan33.JPG);">
        <div class="carousel-container">
        <div class="carousel-content animate__animated animate__fadeInUp">
            <h3> <span>Panchaleshwar</span></h3>
            <!-- <p> पांचाळेश्वर गवतमी तटकरे मध्यान काळी प्रभू नित्याने करी भोजना सुरपती त्या आत्मचरित्र</p>
            <div class="text-center"><a href="" class="btn-get-started">Read More</a></div> -->
        </div>
        </div>
    </div>

    <!-- Slide 3 -->
    <div class="carousel-item" style="background-image: url(../assets/images/home/jali\ cha\ dev07.JPG);">
        <div class="carousel-container">
            <div class="carousel-content animate__animated animate__fadeInUp">
                <h3> <span>Panchaleshwar</span></h3>
                <!-- <p> पांचाळेश्वर गवतमी तटकरे मध्यान काळी प्रभू नित्याने करी भोजना सुरपती त्या आत्मचरित्र</p>
                <div class="text-center"><a href="" class="btn-get-started">Read More</a></div> -->
            </div>
        </div>
    </div>

    </div>

    <a class="carousel-control-prev" href="#heroCarousel" role="button" data-bs-slide="prev">
    <span class="carousel-control-prev-icon bx bx-left-arrow" aria-hidden="true"></span>
    </a>

    <a class="carousel-control-next" href="#heroCarousel" role="button" data-bs-slide="next">
    <span class="carousel-control-next-icon bx bx-right-arrow" aria-hidden="true"></span>
    </a>

    <ol class="carousel-indicators" id="hero-carousel-indicators"></ol>

</div>
</section><!-- End Hero -->

<main id="main">

    <!-- ======= Trainers Section ======= -->
    <section id="trainers" class="trainers">
    <div class="container" data-aos="fade-up">

        <div class="row" data-aos="zoom-in" data-aos-delay="100">
        <div class="col-lg-6 col-sm-6 col-xs-12 col-md-6 d-flex align-items-stretch">
            <div class="member">

            <img src="../assets/images/shrikrishna.jpg" class="img-fluid" alt="">
            <div class="member-content marathi-font">
                <h4 class="marathi-font-lg">श्री कृष्ण चक्रवर्ती महाराज</h4>
                <span>प्रथम कृष्ण</span>
                <p>
                    वसुदेवसुतं देवं कंसचाणूरमर्दनम् |
                    देवकीपरमानन्दं कृष्णं वंदे जगद्गुरुम् ||
                </p>
                <div class="contact">
                    <a [routerLink]="['/panchakrushna', 4]" class="default-button" >Read more</a>
                </div>
            </div>
            </div>
        </div>

        <div class="col-lg-6 col-sm-6 col-xs-12 col-md-6 d-flex align-items-stretch">
            <div class="member">
            <img src="../assets/images/dattaprabhu.jpg" class="img-fluid" alt="">
            <div class="member-content  marathi-font">
                <h4 class="marathi-font-lg">श्री दत्तात्रेय प्रभू</h4>
                <span>द्वितीय कृष्ण </span>
                <p>
                    वसुदेवसुतं देवं कंसचाणूरमर्दनम् |
                    देवकीपरमानन्दं कृष्णं वंदे जगद्गुरुम् ||
                </p>
                <div class="contact">
                    <a [routerLink]="['/panchakrushna', 2]" class="default-button" >Read more</a>
                </div>
            </div>
            </div>
        </div>
        </div>
        <div class="row" data-aos="zoom-in" data-aos-delay="100">
        <div class="col-lg-4 col-sm-6 col-xs-12 col-md-6 d-flex align-items-stretch">
            <div class="member">
            <img src="../assets/images/ShriChakrapaniMaharaj.jpg" class="img-fluid" alt="">
            <div class="member-content  marathi-font">
                <h4 class="marathi-font-lg">श्री चक्रपाणी महाराज </h4>
                <span>तिसरे कृष्ण </span>
                <p>
                    वसुदेवसुतं देवं कंसचाणूरमर्दनम् |
                    देवकीपरमानन्दं कृष्णं वंदे जगद्गुरुम् ||
                </p>
                <div class="contact">
                    <a [routerLink]="['/panchakrushna', 6]" class="default-button" >Read more</a>
                </div>
            </div>
            </div>
        </div>

        <div class="col-lg-4 col-sm-6 col-xs-12 col-md-6 d-flex align-items-stretch">
            <div class="member">
            <img src="../assets/images/govindprabhu.jpg" class="img-fluid" alt="">
            <div class="member-content  marathi-font">
                <h4 class="marathi-font-lg">श्री गोविंद प्रभू</h4>
                <span>चवाथे कृष्ण </span>
                <p>
                    वसुदेवसुतं देवं कंसचाणूरमर्दनम् |
                    देवकीपरमानन्दं कृष्णं वंदे जगद्गुरुम् ||
                </p>
                <div class="contact">
                    <a [routerLink]="['/panchakrushna', 5]" class="default-button" >Read more</a>
                </div>
            </div>
            </div>
        </div>

        <div class="col-lg-4 col-sm-6 col-xs-12 col-md-6 d-flex align-items-stretch">
            <div class="member">
            <img src="../assets/images/chakradharswami.jpg" class="img-fluid" alt="">
            <div class="member-content  marathi-font">
                <h4 class="marathi-font-lg">श्री चक्रधर स्वामी</h4>
                <span>सर्वज्ञ (पाचवे कृष्ण)</span>
                <p>
                    वसुदेवसुतं देवं कंसचाणूरमर्दनम् |
                    देवकीपरमानन्दं कृष्णं वंदे जगद्गुरुम् ||
                </p>
                <div class="contact">
                    <a [routerLink]="['/panchakrushna', 3]" class="default-button" >Read more</a>
                </div>
            </div>
            </div>
        </div>
        </div>

    </div>
    </section><!-- End Trainers Section -->

    <!-- ======= About Section ======= -->
    <section id="about" class="about pt-0">
    <div class="container" data-aos="fade-up">

        <div class="row">
        <div class="col-lg-6 order-1 order-lg-2" data-aos="fade-left" data-aos-delay="100">
            <img src="../assets/images/Panchvatar.jpg" class="img-fluid" alt="">
        </div>
        <div class="col-lg-6 pt-4 pt-lg-0 order-2 order-lg-1 content">
            <h3>Mahanubhav Panth.</h3>
            <p class="fst-italic marathi-font">
            महानुभाव पंथ
            </p>
            <ul>
            <li><i class="bi bi-check-circle"></i> भटमार्ग</li>
            <li><i class="bi bi-check-circle"></i> महात्मा पंथ</li>
            <li><i class="bi bi-check-circle"></i> अच्युत पंथ</li>
            <li><i class="bi bi-check-circle"></i> जयकृष्णी पंथ</li>
            <li><i class="bi bi-check-circle"></i> परमार्ग</li>
            </ul>
            <p class="marathi-font">
            इ.स.१२०० च्या सूमारास महाराष्ट्रात महानुभाव संप्रदाय उदयास आला. “महान अनुभवोस्तेजा बलं वा यस्य सः महानुभावः” या दृष्टीने मोठा तेजाने युक्त असलेल्या लोकांचा मार्ग, तो महानुभाव पंथ, असे म्हटले जाते. या संप्रदायाची संस्थापना सर्वज्ञ श्रीचक्रधरस्वामींनी केलेली असली तरी, मूळात त्यांनी या पंथास स्वतः कोणतेही नांव दीलेले नव्हते. सर्वज्ञ श्रीचक्रधरस्वामींच्या उत्तरापंथे गमना नंतर, जेव्हा पंथाची धुरा नागदेव आचार्यांच्या खांद्यावर आली, त्याकाळी या पंथास “भटमार्ग” असे संबोधल्या जाऊ लागले. “महानुभाव पंथ” या नावने हा पंथ जरी आज ओळखला जात असला, तरी त्याची “महात्मा पंथ”,”अच्युत पंथ”,”जयकृष्णी पंथ”,”परमार्ग” अशी अन्य नावेही पूढील काळात उदयास आली. काही भागात “अच्युतपंथ” उत्तर भारतात “जयकृष्णीपंथ” ही नावे याच पंथाची आहेत.
            </p>
            <a [routerLink]="['/panchakrushna', 1]" class="default-button" >Read more</a>
        </div>
        </div>
        
    </div>
    </section><!-- End About Section -->

    <!-- ======= Counts Section ======= -->
    <section id="counts" class="counts section-bg">
    <div class="container">

        <div class="row counters">

        <div class="col-lg-3 col-6 text-center">
            <span data-purecounter-start="0" [attr.data-purecounter-end]="downloads.getValue().totalVisitors" data-purecounter-duration="1" class="purecounter"></span>
            <p>Total Visitors</p>
        </div>

        <div class="col-lg-3 col-6 text-center">
            <span data-purecounter-start="0" [attr.data-purecounter-end]="downloads.getValue().todaysVisitors" data-purecounter-duration="1" class="purecounter"></span>
            <p>Today's Visitors</p>
        </div>

        <div class="col-lg-3 col-6 text-center">
            <span data-purecounter-start="0" [attr.data-purecounter-end]="downloads.getValue().anvayAppDownloads" data-purecounter-duration="1" class="purecounter"></span>
            <p>Anvay App downloads</p>
        </div>

        <div class="col-lg-3 col-6 text-center">
            <span data-purecounter-start="0" [attr.data-purecounter-end]="downloads.getValue().sarvadhnyaAppDownload" data-purecounter-duration="1" class="purecounter"></span>
            <p>Sarvadhnya App downloads</p>
        </div>

        </div>

    </div>
    </section><!-- End Counts Section -->

   
    

</main><!-- End #main -->

